/**
 * /!\ This file is auto-generated.
 *
 * This is the entry point of your standalone application.
 *
 * There are multiple tags used by the editor to inject code automatically:
 *     - `wle:auto-imports:start` and `wle:auto-imports:end`: The list of import statements
 *     - `wle:auto-register:start` and `wle:auto-register:end`: The list of component to register
 */

/* wle:auto-imports:start */
import { MouseLookComponent } from '@wonderlandengine/components';
import { WasdControlsComponent } from '@wonderlandengine/components';
import { Test } from './test.js';
/* wle:auto-imports:end */

export default function (engine) {
    /* wle:auto-register:start */
    engine.registerComponent(MouseLookComponent);
    engine.registerComponent(WasdControlsComponent);
    engine.registerComponent(Test);
    /* wle:auto-register:end */
}
